var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"exam"},[_c('img',{staticClass:"home_banner",attrs:{"src":_vm.coverData.cover,"alt":""}}),_c('div',{staticClass:"start_btn",on:{"click":_vm.stattBtn}},[_c('img',{attrs:{"src":_vm.coverData.button,"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }